<template>

<div id="registration" class="container-fluid auth">
    <div class="row">
        <div class="col-12 p-0">
            <div class="jumbotron page-header d-flex justify-content-center align-items-center">
                <div class="inner-page-header text-center pb-5">        
                    <span class="icon icon-user-1 mb-3 d-block"></span>
                    <h1>Създаване на профил</h1>
                    <div class="breadcrumbs">
                        <a href="/">Начало</a>
                        <a href="/login" class="router-link-exact-active router-link-active">
                            <span class="separator">/</span>
                            Създаване на профил
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
 <div class="main-page-content">
    <div class="row justify-content-center">

        <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
            <div class="card mb-0 shadow-lg p-0">
                <div class="card-body pt-5 pb-5 pl-1 pr-1">
                    <h2 class="text-center title text-orange">
                        Регистрация
                    </h2>

                    <form>
                        <div class="pt-0 pb-0 pl-4 pr-4 pl-xl-4 pl-xl-4">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="name">Име и фамилия</label>

                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">
                                                    <span class="icon icon-user"></span>
                                                </div>
                                            </div>
                                            <input id="name" type="text" class="form-control input-lg" v-model='model.name' 
                                                name="name" required autocomplete="name" autofocus>
                                        </div>
                                    </div>
                                </div>
                            </div>

                               <!--  <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="last_name">Фамилия</label>

                                            <div class="input-group">
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <span class="icon icon-user"></span>
                                                        </div>
                                                    </div>
                                                     <input id="last_name" type="text" v-model='model.last_name' class="form-control input-lg" 
                                                        name="last_name" required autocomplete="name" autofocus>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="email">E-мейл адрес:</label>

                                            <div class="input-group">
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <span class="icon icon-envelope"></span>
                                                        </div>
                                                    </div>
                                                     <input id="email" type="email" v-model='model.email' class="form-control input-lg" 
                                                        name="email" required autocomplete="email">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="phone">Телефон:</label>

                                            <div class="input-group">

                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <span class="icon icon-phone"></span>
                                                        </div>
                                                    </div>

                                                     <input id="phone" type="number" 
                                                            v-model.number='model.phone' 
                                                            class="form-control input-lg" 
                                                            name="phone" required autocomplete="phone">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="password">Парола:</label>

                                            <div class="input-group">
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <span class="icon icon-key"></span>
                                                        </div>
                                                    </div>
                                                    <input id="password" v-model='model.password' type="password" 
                                                        class="form-control input-lg" name="password" required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="password-confirm">Повтори паролата:</label>

                                            <div class="input-group">
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <span class="icon icon-rotate-cw"></span>
                                                        </div>
                                                    </div>
                                                    <input id="password-confirm" type="password" v-model='pwdRepeat' 
                                                        class="form-control input-lg" name="password_confirmation" required autocomplete="new-password">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="password-confirm">Тип потребител:</label>
                                            <a tabindex="0" data-toggle="popover" data-placement="top" data-container="body" data-trigger="focus" data-original-title="Кой тип потребител съм аз?" data-content="<span class='font-weight-bold'>Възложителят</span> има право да създава проекти за обзавеждане на своето пространство. <br/> <span class='font-weight-bold'>Изпълнителят</span> има същото право, но също така може да участва като дизайнер, доставчик и т.н." class="badge badge-warning popover-trigger" aria-describedby="popover761420">
                                                Инфо
                                            </a>

                                            <select class='form-control custom-select input-lg' id='type' v-model='model.type'>
                                                <option value=1>Възложител</option>
                                                <option value=2>Изпълнител</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            
                                <div class="row">
                            
                                    <div class="col-12">
                                        <form-validator ref='validator' :fields='validatorFields'></form-validator>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-sm-10 offset-sm-1 text-center">
                                        <button @click='register' 
                                                type='button' 
                                                class="btn btn-primary btn-lg" 
                                                :disabled='isLoading'>
                                            Създаване на профил
                                        </button>
                                    </div>
                                </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-12 text-center mt-4">
            <a class="nav-link text-green" href="/login">Вече имаш профил?</a>
        </div>
    </div>
</div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
            
        },

        data() {
            return {
                isReady : false,
                isLoading : false,

                model : {
                    name        : '',
                    last_name   : '',
                    email       : '',
                    password    : '',
                    phone       : '',
                    location    : '',
                    type        : 1,
                },

                pwdRepeat : '',

                validatorFields : [
                    { 
                        selector  : "#name",
                        minLength : 2,
                        customErr : 'Моля въведете вашето име'
                    },
                    // { 
                    //     selector  : "#last_name",
                    //     minLength : 2,
                    //     customErr : 'Моля въведете вашата фамилия'
                    // },
                    { 
                        selector  : "#email",
                        minLength : 2,
                        regex     : this.emailRegex,
                        customErr : 'Моля въведете валиден мейл адрес'
                    },
                    { 
                        selector  : "#phone",
                        minLength : 8,
                        required  : true,
                        regex     : /[0-9 +]+/,
                        customErr : 'Моля въведете вашият телефонен номер'
                    },
                    { 
                        selector  : "#password",
                        minLength : 8,
                        customErr : 'Моля въведете поне 8 символа за парола'
                    },
                   
                    { 
                        selector  : "#password-confirm",
                        minLength : 8,
                        sameAs    : "#password",
                        customErr : 'Моля въведете поне 8 символа за парола'
                    },
                   
                ],

            }
        },

        methods : {

            register : _.debounce( function() {
                var me = this;

                this.$refs.validator.validate({
                    resolve() {

                        me.isLoading = true;

                        me.ajax.call('register', me.model , (r) => {
                            
                            me.isLoading = false;
                            me.isReady = true;

                            if( r.status == 'success' ) {

                                $.notify('Вашата регистрация беше успешна','success');

                                setTimeout( () => {
                                    location.reload();
                                },1000);

                            } else {

                                $.notify( r.message, r.status );

                            }

                        })
                    }
                });

            },500),
        }

    }
</script>
